import { Container } from "./DocumentManagementHeaderStyles";

function DocumentManagementHeader(props) {
  const { title } = props;
  return (
    <Container>
      <h1>{title}</h1>
    </Container>
  );
}

export default DocumentManagementHeader;
